module.exports = __webpack_public_path__ + "img/guide-coconala.b384d62.png";